import { ArrowNarrowRightIcon } from '@heroicons/react/solid';
import { Button, Paper, Stepper, Title } from '@yoast/ui-library';
import { useNavigate } from 'react-router-dom';

import GradientText from '../../components/GradientText';
import PaperFooter from '../../components/PaperFooter';

const Welcome = () => {
  const navigate = useNavigate();
  return (
    <form onSubmit={() => navigate('/setup')}>
      <Paper className="yst-mx-auto yst-flex yst-max-w-2xl">
        <Paper.Header>
          <Title size="1">
            Welcome to <GradientText>Yoast AI Brand Insights</GradientText>!
          </Title>
        </Paper.Header>
        <Paper.Content className="yst-space-y-8">
          <div className="yst-space-y-4 *:yst-text-tiny">
            <p>See how your brand is represented in AI answers.</p>
            <p>
              <b className="yst-font-medium yst-text-slate-800">
                Yoast AI Brand Insights
              </b>{' '}
              shows how often your brand appears, how it's described, and how it
              compares to competitors in tools like ChatGPT and Perplexity.
            </p>

            <p>It only takes three simple steps to get your brand insights:</p>
          </div>

          <div className="yst-flex yst-flex-col yst-items-stretch yst-justify-stretch yst-gap-4 yst-pb-8">
            {[
              {
                title: '1. ADD BRAND INFO',
                description:
                  "Tell us about your brand and where it's active so we can customize your analysis.",
              },
              {
                title: '2. REVIEW QUERIES',
                description:
                  'Edit or approve the queries generated from your input.',
              },
              {
                title: '3. RUN ANALYSIS',
                description:
                  'Run your queries through relevant AI platforms to see how your brand shows up.',
              },
            ].map((step, idx, arr) => (
              <div
                key={step.title}
                className="yst-relative yst-flex yst-flex-col yst-items-stretch"
              >
                <div className="yst-flex yst-flex-row yst-items-center yst-justify-stretch yst-gap-6">
                  <Stepper.Step isActive isComplete={false}>
                    <span className="yst-hidden">{idx + 1}</span>
                  </Stepper.Step>
                  <div className="yst-flex yst-flex-1 yst-flex-col yst-gap-2 yst-rounded yst-border yst-border-slate-200 yst-p-6">
                    <Title size="3" className="yst-font-semibold yst-uppercase">
                      {step.title}
                    </Title>
                    <p className="yst-my-0 yst-py-0">{step.description}</p>
                  </div>
                </div>
                {idx < arr.length - 1 && (
                  <div className="yst-absolute yst-left-[-2px] yst-top-1/2 yst-my-0 yst-ml-[13px] yst-h-full yst-border-l-2 yst-border-l-primary-600" />
                )}
              </div>
            ))}
          </div>
        </Paper.Content>

        <PaperFooter className="yst-justify-end">
          <Button variant="primary" onClick={() => navigate('/setup')}>
            Start your first analysis <ArrowNarrowRightIcon />
          </Button>
        </PaperFooter>
      </Paper>
    </form>
  );
};

export default Welcome;
